document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('bulk-add-to-cart-form');
  const checkboxes = document.querySelectorAll('.select-swatch:not(:disabled)');
  const submitBtn = document.getElementById('bulk-add-to-cart-btn');
  const btnText = document.getElementById('btn-text');
  const btnCount = document.getElementById('btn-count');
  const selectedCountSpan = document.getElementById('selected-products-count');
  const selectedCountInput = document.getElementById('selected-count');

  let selectedProducts = 0;
  
  const savedSelections = JSON.parse(sessionStorage.getItem('productGridSelections') || '{}');
  
  checkboxes.forEach(checkbox => {
    const productId = checkbox.id.replace('select-swatch-', '');
    if (savedSelections[productId]) {
      checkbox.checked = true;
      selectedProducts++;
      updateCardState(checkbox);
    }
  });

  function updateSubmitButton() {
    if (selectedProducts > 0) {
      submitBtn.disabled = false;
      btnText.textContent = 'Add Selected Products to Cart';
      btnCount.classList.remove('tw-hidden');
      selectedCountSpan.textContent = selectedProducts;
      selectedCountInput.value = selectedProducts;
    } else {
      submitBtn.disabled = true;
      btnText.textContent = 'Select products to add to cart';
      btnCount.classList.add('tw-hidden');
      selectedCountInput.value = 0;
    }
  }

  function updateCardState(checkbox) {
    const productCard = checkbox.closest('.product-card-swatch');

    if (checkbox.checked) {
      productCard.classList.add('selected', 'active');
    } else {
      productCard.classList.remove('selected', 'active');
    }
  }
  
  function saveSelections() {
    const selections = {};
    checkboxes.forEach(checkbox => {
      const productId = checkbox.id.replace('select-swatch-', '');
      selections[productId] = checkbox.checked;
    });
    sessionStorage.setItem('productGridSelections', JSON.stringify(selections));
  }

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function () {
      if (this.checked) {
        selectedProducts++;
      } else {
        selectedProducts--;
      }

      updateCardState(this);
      updateSubmitButton();
      saveSelections();
    });
  });

  const productCards = document.querySelectorAll('.product-card-swatch:not(.sold-out)');
  productCards.forEach(card => {
    card.addEventListener('click', function (e) {
      if (
        e.target.type === 'checkbox' ||
        e.target.tagName === 'LABEL' ||
        e.target.tagName === 'A'
      ) {
        return;
      }

      const checkbox = this.querySelector('.select-swatch:not(:disabled)');
      if (checkbox) {
        checkbox.checked = !checkbox.checked;

        if (checkbox.checked) {
          selectedProducts++;
        } else {
          selectedProducts--;
        }

        updateCardState(checkbox);
        updateSubmitButton();
        saveSelections();
      }
    });
  });

  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }

  async function addProductsToCart(products) {
    const cart = document.querySelector('cart-drawer');
    
    const items = products.map(product => ({
      id: product.variantId,
      quantity: 1
    }));

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    
    const formData = new FormData();
    
    items.forEach((item, index) => {
      formData.append(`items[${index}][id]`, item.id);
      formData.append(`items[${index}][quantity]`, item.quantity);
    });

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    delete config.headers['Content-Type'];
    config.body = formData;

    try {
      const response = await fetch(`${routes.cart_add_url}`, config);
      const result = await response.json();

      if (result.status) {
        alert(result.description || 'Error adding products to cart');
        return false;
      }

      if (!cart) {
        window.location = window.routes.cart_url;
        return true;
      }

      cart.renderContents(result);
      
      if (window.publish && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { 
          source: 'product-grid-swatches',
          cartData: result 
        });
      }

      return true;
    } catch (error) {
      alert('Error adding products to cart. Please try again.');
      return false;
    }
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    
    const checkedBoxes = document.querySelectorAll('.select-swatch:checked');

    if (checkedBoxes.length === 0) {
      alert('Please select at least one product to add to cart.');
      return false;
    }

    submitBtn.disabled = true;
    const originalContent = submitBtn.innerHTML;
    submitBtn.innerHTML = '<span>Adding to cart...</span>';

    const selectedItems = [];
    checkedBoxes.forEach(checkbox => {
      const variantId = checkbox.getAttribute('data-variant-id');
      const productTitle = checkbox.getAttribute('data-product-title');
      
      if (variantId && variantId !== 'null' && variantId !== '') {
        selectedItems.push({
          variantId: variantId,
          productTitle: productTitle
        });
      }
    });

    if (selectedItems.length === 0) {
      alert('The selected products are not available. Please select other products.');
      submitBtn.innerHTML = originalContent;
      submitBtn.disabled = selectedProducts === 0;
      return;
    }

    const success = await addProductsToCart(selectedItems);

    if (success) {
      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
        updateCardState(checkbox);
      });
      selectedProducts = 0;
      updateSubmitButton();
      sessionStorage.removeItem('productGridSelections');
    }

    submitBtn.innerHTML = originalContent;
    submitBtn.disabled = selectedProducts === 0;
  });

  updateSubmitButton();
});